import { memo, useState } from "react";
import WorkingPointClientsModal from "../WorkingPointClientsModal";

import { TableItemId } from "../../../../../components/tables/TableWidget";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";

import { TableItemType } from "../../../../../components/tables/tableContext/TableContext";
import { expeditionRoutes } from "../../../../../router/routesConstants";
import { ScheduleWorkingPointsListInterface } from "../../../../../redux/interfaces/expedition.interface";

function ExpeditionScheduleWorkingPointsTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: ScheduleWorkingPointsListInterface;
  tableContext?: any;
}) {
  const [showClients, setShowClients] = useState(false);
  const goToOrganizeWorkingPoint = () => {
    return `/${expeditionRoutes.workingPoints}/${expeditionRoutes.organize}?id=${itemId}&routeId=${crudData?.id_ruta}&adress=${crudData?.adresa}&deliveryPoint=${crudData?.denumire}&locationName=${crudData?.denumire}`;
  };

  const items: ActionMenuItem[] = [
    {
      id: "organize-working-point",
      label: "Organizeaza punctul de lucru",
      icon: "DOCUMENTS",
      section: "manage",
      tooltip: "Deschide organizarea punctului de lucru pe ruta sa.",
      navigate: goToOrganizeWorkingPoint(),
    },
    {
      id: "view-clients",
      label: "Vezi clienti",
      icon: "SPLIT_LIST",
      section: "browse",
      tooltip: "Afiseaza clientii asociati acestui punct de lucru.",
      onClick: () => setShowClients(true),
    },
  ];

  return (
    <>
      <ActionMenu
        items={items}
        minItemsForMenu={2}
        title={crudData?.denumire}
        ariaLabel={`Actiuni pentru punctul de lucru ${
          crudData?.denumire ?? ""
        }`}
      />
      {showClients && (
        <WorkingPointClientsModal
          workingPointId={itemId}
          workingPointName={crudData?.denumire}
          onClose={() => setShowClients(false)}
        />
      )}
    </>
  );
}

export default memo(ExpeditionScheduleWorkingPointsTableActionButtons);
